.wrapper {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: translateY(-16px);
  z-index: 4;
}
